import { useLocation } from "react-router-dom";

import OverviewTab from "./overview";
import TurnoverTab from "./turnover";
import StatsShell, { currentTab } from "./workforce/StatsShell";
import { useStatsFilters } from "./workforce/useStatsData";

const SUBTITLES = {
  overview: "Who works here. The filters apply to every figure on the page.",
  turnover: "Who is leaving, from where and why. The filters apply to every figure on the page.",
};

/** Employee Statistics: Overview (the original cards plus new ones) and
 *  Turnover & retention, as two tabs on the same page. */
const EmployeeStats = () => {
  const filterProps = useStatsFilters();
  const tab = currentTab(useLocation().search);
  return (
    <StatsShell subtitle={SUBTITLES[tab]} filterProps={filterProps} showPeriod={tab === "turnover"}>
      {tab === "turnover" ? <TurnoverTab filters={filterProps.filters} /> : <OverviewTab filters={filterProps.filters} />}
    </StatsShell>
  );
};

export default EmployeeStats;
